import { Form } from 'antd';
import React from 'react';

import InputJsonData from '../../components/InputJsonData/InputJsonData';
import { ItemTaskType, SubTaskType } from '../../types';

export interface IFieldSubTask {
    disabled?: boolean;
    isAccess?: { create: boolean; update: boolean; delete: boolean };
}

const FieldSubTask: React.FC<IFieldSubTask> = ({ disabled, isAccess }) => {
    return (
        <Form.Item<ItemTaskType> label="" name="subtask">
            <InputJsonData<SubTaskType>
                disabled={disabled}
                fieldJsonParam={{
                    status: { type: 'checkbox', defaultValue: false, widthPercent: 5 },
                    name: { type: 'string', defaultValue: '' },
                }}
                effectList={{
                    getIsDelete: (rowData: SubTaskType) => rowData.status,
                    getIsBlockEditField: (rowData: SubTaskType): (keyof SubTaskType)[] => {
                        if (rowData.status) {
                            return ['name'];
                        }
                        return [];
                    },
                }}
                isAccess={isAccess}
            />
        </Form.Item>
    );
};

export default React.memo(FieldSubTask);
